import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { clearStream, startStream } from "@/lib/chatStore";

const GONE = new Set(["conversation_not_found", "not_found"]);

export function SendError({ entry, onEdit }) {
  const code = entry.error?.code;
  const noCredits = code === "insufficient_credits";
  const gone = GONE.has(code);
  const retry = () =>
    startStream({ key: entry.key, conversationId: entry.conversationId, content: entry.userContent, kind: entry.kind, attachments: entry.attachments });
  const edit = () => {
    if (entry.userContent) onEdit(entry.userContent);
    clearStream(entry.key);
  };
  return (
    <div className="flex items-start gap-3 rounded-xl border border-rose-400/20 bg-rose-500/[0.05] p-3.5 text-sm cs-fade-in" data-testid="chat-send-error" data-code={code}>
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-rose-300" strokeWidth={1.8} />
      <div className="min-w-0 flex-1">
        <p className="text-zinc-200" data-testid="chat-send-error-message">{entry.error?.message || "Your message wasn't sent."}</p>
        <p className="mt-0.5 text-xs text-zinc-500">
          Your message hasn't been lost.
          {entry.error?.requestId && <span className="ml-1.5 font-mono text-zinc-600" data-testid="chat-send-error-reference">Ref {entry.error.requestId}</span>}
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {noCredits && (
            <Link to="/plan" className="rounded-full bg-white px-3 py-1.5 text-xs font-medium text-ink-950" data-testid="chat-send-error-plan">
              View plan & usage
            </Link>
          )}
          {gone && (
            <Link to="/" state={{ draft: entry.userContent }} className="rounded-full bg-white px-3 py-1.5 text-xs font-medium text-ink-950" data-testid="chat-send-error-new-chat">
              Start a new chat with this message
            </Link>
          )}
          {!noCredits && !gone && (
            <button type="button" onClick={retry} className="rounded-full bg-white px-3 py-1.5 text-xs font-medium text-ink-950 hover:bg-white/90" data-testid="chat-send-error-retry">
              Retry
            </button>
          )}
          {entry.kind === "message" && (
            <button type="button" onClick={edit} className="rounded-full border border-white/15 px-3 py-1.5 text-xs text-zinc-300 hover:bg-white/[0.05]" data-testid="chat-send-error-edit">
              Edit message
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
